import {CheckoutFactory, ICartPosition} from "@connox/typescript-library";
import * as Sentry from "@sentry/browser";
import * as React from "react";
import * as ReactDOM from "react-dom";
import {getShopId} from "../../lib/getShopId";
import CartWrapperModal from "../../lib/ModalWindow/CartWrapperModal";
import window from "../../lib/WindowExtended";
import {isCart, useUnsafeCartContext} from "../CartContextProvider/CartContextProvider";

const Badge: React.FC<{count: number}> = (props) => {
  if (props.count === 0) {
    return null;
  }

  return <span className="icon-badge icon-badge--green">{props.count}</span>;
};

const CartIcon: React.FC = () => {
  const context = useUnsafeCartContext();
  const params = new URLSearchParams(window.location.search);

  const closeFunction = () => {
    if (params.get("gotoStep")) {
      params.delete("gotoStep");
      params.delete("AuthenticationStatus");
      window.location.href =
        window.location.origin + window.location.pathname + (params.toString().length ? "?" + params.toString() : "");
    } else if (isCart(context) && context.isIntoCheckout) {
      CheckoutFactory.generateCheckout(getShopId(), context.cart).then((checkout) => {
        if (checkout.isCompleted) {
          window.location.reload();
        }
      }, Sentry.captureException);
    }

    if (context) {
      context.setIsCartVisible(false);
    }
  };

  if (!context) {
    // FYI if this happens it might be an error, so maybe log it, but mvp`ing through this
    return null;
  }

  const itemCount = isCart(context) ? context.cart.positions.filter((position: ICartPosition) => {
    return position.reference && position.reference.itemId && !!position.item;
  }).length : 0;

  return (
    <div onClick={() => context.setIsCartVisible(true)}>
      <Badge count={itemCount} />
      <span className="svg svg-link svg-icon-cart">Shopping cart</span>
      <CartWrapperModal isCartVisible={context.isCartVisible} closeFunction={closeFunction} />
    </div>
  );
};

const CartIconPortal: React.FC<{targetNode: HTMLSpanElement | null; root: HTMLSpanElement | null}> = (props) => {
  const {targetNode, root} = props;

  React.useEffect(() => {
    if (!root || !targetNode) {
      return;
    }

    root.style.display = "inline-block";
    root.style.cursor = "pointer";
    targetNode.replaceWith(root);
  }, []);

  if (!root || !targetNode) {
    return null;
  }

  return ReactDOM.createPortal(<CartIcon />, root);
};

export default CartIconPortal;
